<ccl-route-tabs>
    <ccl-route-tab
        tabTitle="Featured"
        route="highlighted"
        [hidden]="
            !(sharedService.catalogLayoutConfig.vipUnit == 'card' || sharedService.catalogLayoutConfig.vipUnit == 'list')
        "
    ></ccl-route-tab>
    <ccl-route-tab tabTitle="General" route="general"> </ccl-route-tab>
</ccl-route-tabs>
<ccl-section-wrapper>
    <ccl-content-section>
        <router-outlet></router-outlet>
    </ccl-content-section>
</ccl-section-wrapper>
